<template>
<div class="row buttons-with-margin">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">All Docs With Attachments ({{ tableData.length }}) {{ allAttachmentsSize }}</h4>
        </div>
        <div class="card-content" v-loading="loading">
          <el-table class="table-striped"
                    :data="tableData"
                    :default-sort="{prop: 'id'}"
                    v-loading="loading"
                    style="width: 100%"
                    >
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="filesService" sortable label="Arquivos"></el-table-column>
            <el-table-column prop="lengths" sortable label="Tamanhos"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import _ from 'lodash'
import swal from 'sweetalert2'

export default {
  components: {},
  data () {
    return {
      tableData: [],
      lengths: []
    }
  },
  computed: {
    loading () {
      return this.tableData <= 0
    },
    allAttachmentsSize () {
      return this.getReadableFileSizeString(_.sum(_.flattenDeep(this.lengths)))
    }
  },
  created () {
    this.fetch(this.$route.params.connection)
  },
  watch: {},
  methods: {
    fetch (connection) {
      Couchdb.connection(connection).createView('commands', 'docsWithAttachment', {
        map:
          `function (doc) {
            if(doc._attachments !== undefined) {
              emit(doc._id, doc._attachments);
            }
          }`
      })
      .then(result => {
        Couchdb.connection(connection).view('commands', 'docsWithAttachment')
        .then(result => {
          let lengths = []
          this.tableData = result.rows.map(item => {
            let lengthsForHumans = []
            if (item.value === null || item.value === undefined) {
            } else {
              for (let file of Object.getOwnPropertyNames(item.value).sort()) {
                let length = item.value[file].length
                lengths.push(length)
                lengthsForHumans.push(this.getReadableFileSizeString(length))
              }
              return {
                id: item.id,
                key: item.key,
                files: Object.getOwnPropertyNames(item.value).sort(),
                lengths: lengthsForHumans
              }
            }
          })
          this.lengths = lengths
        })
        .catch(err => {
          swal({
            width: 1000,
            title: 'Ocorreu um erro ao executar essa ação.',
            text: JSON.stringify(err),
            type: 'error',
            confirmButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          })
        })
      })
      .catch(err => console.log(err))
    },
    getReadableFileSizeString (fileSizeInBytes) {
      let i = -1
      let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB']
      do {
        fileSizeInBytes = fileSizeInBytes / 1024
        i++
      } while (fileSizeInBytes > 1024)
      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i]
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Commands/ListAttachments.vue